export const SECTION_TITLE_DISTRIBUTOR = 'Distributor';
export const SECTION_TITLE_DEALER = 'Dealers';
export const SECTION_TITLE_EDITORIAL_REVIEWS = 'Editorial Reviews';
export const SECTION_TITLE_CONSUMER_REVIEWS = 'Consumer Reviews';
export const SECTION_TITLE_SIMILAR_NEW_CAR = 'Similar New Cars';
export const SECTION_TITLE_DISCUSSIONS = 'Related Discussions';
export const SECTION_TITLE_RECOMMENDED_FOR_YOU = 'Recommended For You';
export const SECTION_TITLE_RECOMMENDED_TYRES = 'Recommended Tyres';

export const STAR_RATING_ICON_SIZE_DEFAULT = 14;

export const NEW_CARS_COMPARE_LIST_LOCAL_STORAGE_KEY = 'newCarsCompareList';
export const UPCOMING_CAR_PROMPT = 'This is a new model that has yet to be launched. Expected Launch date is'; // @suppress longLineCheck
